


<app-website-header></app-website-header>

<div class="container-fluid">

    <section class="about">
        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>


        <div class="row" >
            <div class="col-sm-1"></div>

            <div class="about-image">
                <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 45px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: 0.32px;
                text-align: left;
                color: #ff6d11;">Services</p>
                <p style="margin-top:-33px;"><img src="assets/section-images/Path 336.png"> </p>
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>
        <div class="row" >
            <div class="col-sm-1"></div>

            <div class="col-sm-2" style="margin-left: -14px;">
                    <a href="federal" class="services"><p style="color: #ff6d11;"> <span style="font-weight: bolder;color: #ff6d11;" > ></span> Federal & State Filing  </p></a>
                    <a href="itIn" class="services"><p ><span style="font-weight: bolder;"> > </span> ITIN Preparation  </p></a>
                    <a href="fbar"class="services"><p > <span style="font-weight: bolder;" > ></span> FBAR & FATCA Compliance  </p></a>
                    <a href="tax"class="services"><p> <span style="font-weight: bolder;" > ></span> Tax Representation  </p></a>
                    <a href="advanced"class="services"><p> <span style="font-weight: bolder;" > ></span> Advanced Tax Planning  </p></a>
                    <a href="amendment"class="services"><p> <span style="font-weight: bolder;" > ></span> Amendment Filing  </p></a>
                    <a href="evaluation"class="services"><p> <span style="font-weight: bolder;" > ></span> Tax Evaluation  </p></a>
                    <a href="filing"class="services"><p> <span style="font-weight: bolder;" > ></span> Extension Filing  </p></a>
                 </div>


            <div class="col-sm-7" style="margin-left: 105px;">
                <p style="font-family: Raleway;
                font-size: 24px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.21;
                letter-spacing: 0.24px;
                text-align: left;
                color: #ff6d11;" >Federal & State Filing </p>
                <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.75;
                letter-spacing: 0.13px;
                text-align: left;
                color: #000000;"> Our tax professionals will do everything from entering the data on all the numerous IRS forms after vigilant analysis with the information and documents provided to us by the clients. The following are the different forms that are usually filed with IRS and also depicts the planning, preparation and filing process at Evolv Tax.</p>

                <p style="font-family: Raleway;
                font-size: 22px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.18;
                letter-spacing: 0.22px;
                text-align: left;
                color:#ff6d11;">Tax Return Forms</p>
                <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.75;
                letter-spacing: 0.13px;
                text-align: left;
                color: #000000;">Resident Tax Returns – 1040, 1040A, 1040-EZ <br>
                    Non-Resident Tax Returns – 1040NR, 1040NR-EZ <br>
                    Amended Tax Return – 1040X<br>
                    Tax return Preparation –Federal, State, City & Local</p>

                    <p style="font-family: Raleway;
                    font-size: 22px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.18;
                    letter-spacing: 0.22px;
                    text-align: left;
                    color:#ff6d11;">Return Preparation and Filing Process</p>
                    <p >
                        <span class="pumpkin-color">1.</span> <span class="services-text">Your tax return can be filed electronically so you will get a refund back quicker.</span><br>  
                        <span class="pumpkin-color">2.</span><span class="services-text">We ensure that your returns don’t miss out the deductions, credits that you are eligible for.</span>    <br>                     
                        <span class="pumpkin-color">3.</span><span class="services-text">The returns will be signed electronically by a tax professional governed by the IRS code as a paid preparer.</span><br>
                        <span class="pumpkin-color">4.</span><span class="services-text">All the data will pass through our Quality assurance process, multiple reviews will be carried out on your tax return at various levels.</span><br> 
                        <span class="pumpkin-color">5.</span><span class="services-text">Non Resident returns will be signed by our Paid Preparer and we file paper returns in an expedited fashion for better tracking and faster refund.</span>
                    </p>
                        <p style="font-family: Raleway;
                        font-size: 22px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.18;
                        letter-spacing: 0.22px;
                        text-align: left;
                        color:#ff6d11">Tax Planning Areas</p>
                        <p style="font-family: Raleway;
                        font-size: 16px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.75;
                        letter-spacing: normal;
                        text-align: left;
                        color: #000000;">We offer tax planning in the following areas :-</p>
                        <p><span class="pumpkin-color">1.</span><span class="services-text">A study of Itemized v/s Standard deduction</span><br>
                            <span class="pumpkin-color">2.</span><span class="services-text">Stock options (ESOP) or Stock purchase plans (ESPP) tax planning</span> <br>
                            <span class="pumpkin-color">3.</span><span class="services-text">Rental Income /Loss VS Itemised Deductions</span> <br>
                            <span class="pumpkin-color">4.</span><span class="services-text">Investments into retirement plans like 401K, IRA tax planning services, etc.</span><br>
                            <span class="pumpkin-color">5.</span><span class="services-text">Free Refund Estimates for current year (TY2017) in Just 24 To 36 Hours**</span><br>
                            <span class="pumpkin-color">6.</span><span class="services-text">Free Tax evaluation for 3 years (TY2016, 2015, 2014)</span> 
                        </p>
            </div>
            <div class="col-sm-2"></div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 40px"></div>
        </div>



        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 40px"></div>
        </div>

       

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 50px"></div>
        </div>

    
        <div class="row">
            <div class="col-sm-1"></div>

            <div class="col-sm-5">
                <p class="need-help">NEED HELP?</p> <br>
                <p class="need-content">
                        Contact our customer support team if you have any further questions. We are here to help you out.
                </p> <br>

                 <a href="tel:+1(888)690-5754">
                        <button class="btn  btn-sm Number" id="right" style="width: 250px;
                                    height: 50px;
                                    object-fit: contain;
                                    border-radius: 25px;
                                    background-color: #ff6d11;
                                    color: white;">
                        +1 (888) 690 - 5754 &nbsp;
                    </button>
                    </a>
            </div>

            <div class="col-sm-5">
                <img src="assets/section-images/Group 1364.png">
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 65px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>
    </section>

</div>

<app-website-footer></app-website-footer>